module.exports = __webpack_public_path__ + "img/pic_dianfanbao2.97edb85a.png";